import { Controller } from "@hotwired/stimulus"

// Switches the pricing cards between monthly and annual pricing in place, with no
// page reload. Price/CTA blocks are tagged `priced` with a `data-interval`; the
// matching interval is shown and the rest hidden. `tab` elements are the toggle
// buttons and get active styling. Applies changes directly (no value observer) so
// behavior is independent of Stimulus value-callback timing.
export default class extends Controller {
  static targets = ["tab", "priced"]
  static values = { initial: String }

  connect() {
    // An explicit initial value (e.g. ?interval=year deep links from emails)
    // wins; otherwise the first tab's interval is the default.
    const fallback = this.tabTargets.find((t) => t.dataset.interval)?.dataset.interval || "month"
    this.apply(this.hasInitialValue && this.initialValue ? this.initialValue : fallback)
  }

  select(event) {
    this.apply(event.params.interval)
  }

  apply(interval) {
    this.pricedTargets.forEach((el) => {
      el.classList.toggle("hidden", el.dataset.interval !== interval)
    })

    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.interval === interval
      // Tailwind active styles (legacy marketing layout) …
      tab.classList.toggle("bg-white", active)
      tab.classList.toggle("text-cb-navy-900", active)
      tab.classList.toggle("shadow-sm", active)
      tab.classList.toggle("text-slate-500", !active)
      // … and the Cobalt-Ink .billtoggle active class (new design).
      tab.classList.toggle("on", active)
    })
  }
}
